module.exports = __webpack_public_path__ + "media/metaverse-1.d0ec23ca.mp4";